import { configureStore } from '@reduxjs/toolkit';

const noopReducer = (state: Record<string, never> = {}) => state;

// Redux store with RTK
export const store = configureStore({
  // When no slices are mounted, Redux Toolkit warns if `reducer: {}`.
  // Using a root noop reducer keeps state shape stable (no extra keys).
  reducer: noopReducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
